import React, { forwardRef, MutableRefObject } from 'react'
import { Col, Container, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import ButtonFullWidth from '../../../components/ButtonFullWidth'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'

interface UpdateGroupFooterProps {
  isLoading: boolean
  goToCloseGroup: () => void
}

const UpdateGroupFooter = (
  { isLoading, goToCloseGroup }: UpdateGroupFooterProps,
  ref: MutableRefObject<HTMLButtonElement>,
) => {
  return (
    <Container form>
      <Row>
        <Col form="full">
          <ButtonFullWidth
            data-testid="updateGroupButton"
            type="submit"
            form="groupForm"
            disabled={isLoading}
          >
            <Message id="update.updateButton" />
          </ButtonFullWidth>
        </Col>
      </Row>
      {!isCoverOnCreateFlowEnabled() && (
        <Row>
          <Col form="full">
            <ButtonFullWidth
              variant="secondary"
              onClick={goToCloseGroup}
              data-testid="goToCloseGroupButton"
              ref={ref}
            >
              <Message id="update.closeGroupButton" />
            </ButtonFullWidth>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default forwardRef(UpdateGroupFooter)
